/* eslint-disable @typescript-eslint/no-inferrable-types, no-restricted-properties, no-multi-assign */
// https://stash.odp.cba/projects/DP/repos/homeinsuranceclaims/browse/src/app/
// HomeInsuranceClaims.Web.Frontend/src/scripts/utils/scroller.ts

import { STYLES } from '../constants';
import { animationFrame } from './animationFrame';

// Smooth scroll function
export const scrollToY = (
  scrollTargetY: number = 0,
  loopFunction: (recursion: () => void) => void,
  completeCallback?: () => void,
): void => {
  const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  const speed = 200;
  let currentTime = 0;
  const time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));

  // add animation loop
  function tick() {
    if (typeof loopFunction !== 'undefined') {
      currentTime += 1 / 60;

      let loopTime = currentTime / time;
      const halfLoop = (loopTime /= 0.5);
      let segments = 0;
      if (halfLoop < 1) {
        segments = 0.5 * Math.pow(loopTime, 5);
      } else {
        segments = 0.5 * (Math.pow(loopTime - 2, 5) + 2);
      }

      if (loopTime < 1) {
        loopFunction(tick); // use requestAnimationFrame
        window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * segments);
      } else {
        window.scrollTo(0, scrollTargetY);

        if (completeCallback) {
          completeCallback();
        }
      }
    } else {
      // Use regular scroll if the animation function is not supported
      window.scrollTo(0, scrollTargetY);

      if (completeCallback) {
        completeCallback();
      }
    }
  }

  // call the loop once to get started
  tick();
};

export const scrollToAndFocusId = (id: string): void => {
  const destinationBlade = document.getElementById(`blade-${id}`);
  if (!destinationBlade) {
    return;
  }

  let bladeYPosition = destinationBlade.offsetTop;

  // Remove navigation header height
  bladeYPosition = Math.max(0, bladeYPosition - STYLES.headerHeight);

  // Scroll to element with id
  scrollToY(bladeYPosition, animationFrame, () => {
    // Set focus once animation has finished
    focusBladeHeading(destinationBlade);
  });
};

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const focusBladeHeading = (parent: HTMLElement | null) => {
  if (!parent) {
    return;
  }

  const headingSelector = 'h1, h2, h3, h4, h5, h6';
  const headingElement = parent.querySelector(headingSelector) as HTMLElement;

  if (headingElement) {
    headingElement.setAttribute('tabindex', '-1');
    headingElement.focus();
  } else {
    // Fallback when no heading on the blade
    const bladeFocusableElement = parent.querySelector(
      'input:not([disabled]), select:not([disabled]), button:not([disabled])',
    ) as HTMLElement;
    if (bladeFocusableElement) {
      bladeFocusableElement.focus();
    }
  }
};
